import React, { useEffect, useState } from 'react'

import selflyLogo from './../images/selfly-logo.png'
import i18n from '../i18n';
import { t } from 'i18next';
import countries from '../countries.json'
import icons from './../images/icons.svg'

const Header = ({ device, locationName, selectedLanguage, setSelectedLanguage, organizationName }) => {
    const [fallbackLang, setFallbackLang] = useState('en');


    useEffect(() => { setSelectedLanguage(i18n.resolvedLanguage) })

    const getFallbackLanguageSelect = () => {
        const fallbackLangObj = countries.find(c => c.code === fallbackLang.toUpperCase())
        if (fallbackLangObj && fallbackLang !== selectedLanguage) {
            return <div onClick={() => {
                setFallbackLang(selectedLanguage)
                setSelectedLanguage(fallbackLang)
                i18n.changeLanguage(fallbackLang)
                }}
                className='langSelector'>
                    <svg>
                        <use xlinkHref={`${icons}#icon-world`}></use>
                    </svg>                    
                    <span>{fallbackLang.toUpperCase()}</span>
                </div>
        }
    }

    return (
        <>
            <div className="header">
                <div className="header__logo">
                    <img className="header__logo-img" src={selflyLogo} alt="selfly-logo" />
                </div>
                <div className="header__title">
                    <div className="header__title-text">
                        {t('headerThankYou')}
                    </div>

                    <div className="header__title-info">
                        <span>{device && device.organizationId && (<>{organizationName}</>)}</span>
                    </div>

                </div>
            </div>
            {getFallbackLanguageSelect()}
        </>
    )
}

export default Header;